import { render, staticRenderFns } from "./UserRecipeList.vue?vue&type=template&id=587bfa0a&scoped=true"
import script from "./UserRecipeList.vue?vue&type=script&lang=js"
export * from "./UserRecipeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587bfa0a",
  null
  
)

export default component.exports